import { useCallback } from 'react'
import { Handle, Position } from '@xyflow/react'
import armLogo from '@/assets/postgre.png'

function PostgresNode({ data, isConnectable }) {
  const onChange = useCallback((evt) => {}, [])

  return (
    <div className="custom-node-robots robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div></div>
          <div className="text-center">
            <a href={import.meta.env.VITE_PGADMIN_ADDRESS} target="_blank">
              <img src={armLogo} alt="Postgres Logo" className="custom-node-robots-logo" />
            </a>
          </div>
          <div className="text-center">
            <b>Postgres</b>
          </div>
        </div>
      </div>

      <Handle type="target" position={Position.Left} />
    </div>
  )
}

export default PostgresNode
